import React, { useState, Fragment, useEffect, useRef } from "react";
import _ from "lodash";
import "./detailsMenu.css";

let SCROLL_TIMEOUT = null;

const DetailMenu = (props) => {
  let containerREf = useRef(null);
  const [stretchAnimFlag, setStretchAnimFlag] = useState(true);
  const [scrollVar, setScrollVar] = useState(false);
  const { homeMenuReset } = props;

  const [selectedLink, setSelectedLink] = useState(
    props.selectedLink == null || props.selectedLink == ""
      ? { title: "" }
      : props.selectedLink
  );

  useEffect(() => {
    const animTime = setTimeout(() => {
      setStretchAnimFlag(false);
    }, 1500);
    return () => {
      clearTimeout(animTime);
    };
  }, []);
  useEffect(() => {
    clearTimeout(SCROLL_TIMEOUT);
    const { scrollTop, clientHeight, scrollHeight } = containerREf.current;
    if (scrollTop + clientHeight === scrollHeight) {
      setScrollVar(false);
      return;
    } else if (scrollTop + clientHeight !== scrollHeight && scrollVar) {
      SCROLL_TIMEOUT = setTimeout(() => {
        setScrollVar(false);
      }, [1000]);
    }
  }, [scrollVar]);

  useEffect(() => {
    const throttledScroll = _.throttle(onScrollPerforme, 5);
    let _containerREf = containerREf.current;
    _containerREf.addEventListener("scroll", throttledScroll);
    return () => _containerREf.removeEventListener("scroll", throttledScroll);
  }, []);

  const linkChanged = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedLink(item.fields.title);
    if (props.onChange != null) props.onChange(item);
  };
  const backHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    homeMenuReset();
  };
  const onScrollPerforme = () => {
    const { scrollTop, clientHeight, scrollHeight } = containerREf.current;
    //dont setScroll when eighty percent of scroll is done
    if (scrollTop + clientHeight >= scrollHeight * 0.95) {
      return;
    } else {
      setScrollVar(true);
    }
  };

  return (
    <>
      <div
        ref={containerREf}
        // onScroll={(e) => onScroll(e)}
        style={{ height: "100vh", overflowY: "auto" }}
        onClick={(e) => backHandler(e)}
      >
        <ul className={stretchAnimFlag ? `detailMenuUl` : ""}>
          {props.links.map((item, index) => {
            return (
              <li
                style={{
                  display: "inline-block",
                }}
                className={` generalClassItem  ${selectedLink == item.fields.title ? "current-menu-item" : ""
                  }`}
                onClick={(e) => linkChanged(e, item)}
              >
                <span
                  style={{ display: "inline" }}
                // className={`${scrollVar ? "testitem" : null} `}
                >
                  {item.fields.title.split(" ")[0]}
                  {item.fields.title.split(" ")[1] != null && (
                    <span>
                      <br /> {item.fields.title.split(" ")[1]}
                    </span>
                  )}
                  {item.fields.title.split(" ")[2] != null && (
                    <span>
                      <br /> {item.fields.title.split(" ")[2]}
                      <br />
                    </span>
                  )}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default DetailMenu;
